document.addEventListener('DOMContentLoaded', function () {
  const confirmationModalButtons = document.querySelectorAll('.js-trigger-confirmation-modal');
  const templates = document.querySelectorAll('template');

  if (!confirmationModalButtons.length || !templates.length) {
    return;
  }

  const forms = document.querySelectorAll('.js-create-subscription-form');

  for (const form of forms) {
    const confirmationModalButton = form.querySelector('.js-trigger-confirmation-modal');
    const subscriptionAmountInput = form.querySelector('.js-subscription-amount');

    confirmationModalButton.addEventListener('click', function () {
      if (form.reportValidity()) {
        const { missingQa } = confirmationModalButton.dataset;

        if (missingQa) {
          displayQaRequiredModal();

          return;
        }

        const { losses_capacity } = subscriptionAmountInput.dataset;

        if (!!losses_capacity && parseInt(subscriptionAmountInput.value, 10) > parseInt(losses_capacity, 10)) {
          displayWarningModal(form);

          return;
        }

        continueSubscriptionFlow(form);
      }
    })
  }

  function displayQaRequiredModal() {
    const modal = document.getElementById('qaRequiredModal');
    bootstrap.Modal.getOrCreateInstance(modal).show();
  };

  async function displayWarningModal(form) {
    try {
      const result = await Swal.fire({
        template: '#subscriptionWarningModal',
        willOpen: () => {},
      });

      if (result.isConfirmed) {
        continueSubscriptionFlow(form);

        return;
      }
    } catch (error) {
      console.error(error);
    }
  };

  async function continueSubscriptionFlow(form) {
    const currentLocale = getCurrentLocale();

    try {
      const result = await Swal.fire({
        template: '#subscriptionConfirmationModal',
        willOpen: () => {
          const subscriptionConfirmationModal = document.querySelector('#subscriptionConfirmationModal');
          const amount = document.querySelector('#amount');
          const projectName = document.querySelector('#project_name');
          const investorName = document.querySelector('#investor_name');

          const subscriptionAmount = parseInt(form.querySelector('.js-subscription-amount').value, 10);
          const selectedCurrency = subscriptionConfirmationModal.dataset.projectCurrency;
          const formatter = new Intl.NumberFormat(currentLocale, { style: 'currency', currency: selectedCurrency });

          amount.innerText = formatter.format(subscriptionAmount);

          if (projectName) {
            projectName.innerText = subscriptionConfirmationModal.dataset.projectName;
          }

          if (investorName) {
            const selector = '#select2-subscription_users_profile_id-container';
            const currentInvestorName = document.querySelector(selector)?.innerText || '';
            investorName.innerText = parseName(currentInvestorName);
          }
        }
      });

      if (result.isConfirmed) {
        form.submit();
        document.querySelector('.swal2-confirm').setAttribute('disabled', true);
      }
    } catch (error) {
      console.error(error);
    }
  };

  function parseName(name) {
    const nameParts = name.split(' - ');

    if (nameParts.length == 2) {
      return nameParts[0];
    }

    if (nameParts.length == 3) {
      const fullName = nameParts[1];
      const companyName = nameParts[0];

      return `${companyName} (${fullName})`;
    }
  };
});
